import { graphql } from '@/gql'

export const CreateRecruiterCandidateMutation = graphql(/* GraphQL */ `
  mutation createRecruiterCandidate($input: CreateRecruiterCandidateInput!) {
    createRecruiterCandidate(input: $input) {
      ...RecruiterCandidateFragment
    }
  }
`)

export const UpdateRecruiterCandidateMutation = graphql(/* GraphQL */ `
  mutation updateRecruiterCandidate($input: UpdateRecruiterCandidateInput!) {
    updateRecruiterCandidate(input: $input) {
      ...RecruiterCandidateFragment
    }
  }
`)

export const DeleteRecruiterCandidateMutation = graphql(/* GraphQL */ `
  mutation deleteRecruiterCandidate($input: DeleteRecruiterCandidateInput!) {
    deleteRecruiterCandidate(input: $input) {
      id
    }
  }
`)
